export class ReportTemplateService {
  static substituteRequirementsV2 = (
    strings,
    requirementsArray,
    parsedValue,
    avoidTag = false,
    replaceFunction = null,
    showNotFound = true,
  ) => {
    let newStrings = [...strings];
    requirementsArray.forEach(({ model, requirements }) => {
      if (requirements && requirements.length > 0) {
        newStrings = resolveRequirements(newStrings, requirements, parsedValue, model, avoidTag, replaceFunction, showNotFound);
      } else if (parsedValue[model]) {
        newStrings = textVariableReplace(newStrings, `${model}`, parsedValue[model], avoidTag, replaceFunction);
      }
    });
    newStrings = findImages(newStrings);
    newStrings = avoidTag
      ? textVariableReplace(newStrings, '.*?', '', true, replaceFunction, showNotFound)
      : recoverMissingValues(newStrings, replaceFunction, showNotFound);

    return newStrings;
  };
}

const findImages = (newStrings) => {
  const variableStaticName = 'image';
  let parser = new DOMParser();
  let images = [];

  newStrings.forEach((s) => {
    const doc = parser.parseFromString(s, 'text/html');
    doc.querySelectorAll('.imageWrapper').forEach((img) => {
      const src = img.getAttribute('data-src');
      const name = img.getAttribute('data-name') ?? variableStaticName;
      images = [...images, { src, name }];
    });
  });

  if (!images.length) return newStrings;

  let modifedStrings = [...newStrings];
  images.forEach((image) => {
    const { src, name } = image;

    modifedStrings = modifedStrings.map((string) => {
      return string ? string.replaceAll(new RegExp(`\\$\\{${name}\\}`, 'gi'), `<img src="${src}" />`) : string;
    });
  });

  return modifedStrings;
};

const recoverMissingValues = (newStrings, replaceFunction, showNotFound) => {
  const results = newStrings.map((string) => (string ? string.match(new RegExp(`\\$\\{.*?\\}`, 'gi')) : ''));
  const existsResults = results.map((el) => el);
  return newStrings.map((currentString, index) => {
    return existsResults[index]
      ? substituteMissingValues(currentString, existsResults[index], replaceFunction, showNotFound)
      : currentString;
  });
};

const substituteMissingValues = (currentString, missingVariables, replaceFunction, showNotFound) => {
  const STARTVAR = '{',
    ENDVAR = '}';
  let modified = currentString;
  missingVariables.forEach((currentMissing) => {
    let check = currentMissing.substring(currentMissing.indexOf(STARTVAR) + 1, currentMissing.indexOf(ENDVAR));
    check = check.replace(/<\/?[^>]+(>|$)/g, '');
    modified = modified.replaceAll(new RegExp(`\\$\\{${check}\\}`, 'gi'), replaceValue('', check, false, replaceFunction, showNotFound));
  });
  return modified;
};

const resolveRequirements = (newStrings, requirements, parsedValue, model, avoidTag, replaceFunction, showNotFound) => {
  let result = newStrings;

  requirements.forEach((requirement) => {
    if (parsedValue[model]) {
      // is a complex object from dynamic method
      if (requirement.value && parsedValue[model][requirement.value]) {
        const { style, value, classes } = parsedValue[model][requirement.value];
        const substituteValue = style ? createStyle(style, value, classes) : value;
        if (substituteValue) {
          result = textVariableReplace(result, requirement.parsed, substituteValue, avoidTag, replaceFunction, showNotFound);
        }
      } else if (parsedValue[model][requirement]) {
        result = textVariableReplace(
          result,
          `${model}.${requirement}`,
          parsedValue[model][requirement],
          avoidTag,
          replaceFunction,
          showNotFound,
        );
      } else if (requirement == 'bar_code_ncartella') {
        let nr_cartella = parsedValue[model]['nr_cartella'];
        if (nr_cartella)
          result = textVariableReplace(result, `${model}.${requirement}`, nr_cartella, avoidTag, replaceFunction, showNotFound);
      }
    }
  });

  return result;
};

const textVariableReplace = (newStrings, check, value, avoidTag, replaceFunction, showNotFound) => {
  return newStrings.map((string) => {
    return string
      ? string.replaceAll(new RegExp(`\\$\\{${check}\\}`, 'gi'), replaceValue(value, check, avoidTag, replaceFunction, showNotFound))
      : string;
  });
};

const replaceValue = (value, check, avoidTag, replaceFunction, showNotFound) => {
  if (replaceFunction) return replaceFunction(value, check);
  if (check.includes('digital_signature')) return replaceImageTag(value, check);
  if (check.includes('bar_code_ncartella') && value) return replaceBarCodeNrCartella(value, check);
  if (check.includes('radio_input')) return replaceRadioInput(value, check);
  if (avoidTag) return value;

  let wrapper = document.createElement('section');
  let textToPrint = value || showNotFoundLabel(showNotFound);
  wrapper.innerHTML = textToPrint;
  const inline = `<var title="${check}" data-exist="${!!value}" data-title="${check}" data-variable="{${check}}" class="variableReplace">${textToPrint}</var>`;
  const block = `<section title="${check}" data-exist="${!!value}" data-title="${check}" data-variable="{${check}}" class="variableReplace">${textToPrint}</section>`;

  return !!wrapper.querySelector('*') ? block : inline;
};

const showNotFoundLabel = (showNotFound) => {
  return showNotFound ? '< --NOT_FOUND-->' : '';
};

const replaceImageTag = (value, check) => {
  return `<img style="height: 50px; width: auto;" src="${value?.src || value}" />`;
};

const replaceRadioInput = (value, check) => {
  let radioValue = check.split('.')[1];
  let splitted_string = radioValue.split('-');
  if (splitted_string && splitted_string[0] && new RegExp(/^[a-zA-Z0-9]+$/).test(splitted_string[0]))
    return `<input type="radio" name="${splitted_string[0]}" id="${check}" class="js-copy-value consent-variable-values" ${value ? 'checked' : ''} />`;
  else return '';
};

const replaceBarCodeNrCartella = (value, check) => {
  let qr_code_container = document.createElement('img');
  qr_code_container.style.cssText = 'height:50px;max-width:350px!important;';
  window.JsBarcode(qr_code_container, value, {
    height: 8,
    displayValue: false,
    marginTop: 1,
    marginBottom: 1,
  });

  return qr_code_container.outerHTML;
};

const createStyle = (style, value, classes) => {
  switch (style) {
    case 'list':
      return value.list && value.list.length > 0 ? createList(value, classes) : '';
    case 'table':
      return value.list && value.list.length > 0 && value.header ? createTable(value, classes) : '';
  }
};

const createList = (value, classes) => {
  const options = tagBuilder(value.list, 'li');
  return `<ul class="${classes}">${options}</ul>`;
};

const createTable = (table, classes) => {
  const trHead = tagBuilder(table.header, 'th');
  const head = `<tr>${trHead}</tr>`;
  let tr_list = table.list.map((el) => `<tr>${cellBuilder(el, 'td')}</tr>`).join('');
  const body = `<tbody>${head}${tr_list}</tbody>`;
  return `<table class="${classes}">${body}</table>`;
};

const cellBuilder = (list, tag) => {
  return list
    .map((el) => {
      const head = tagBuilder([el], 'span', 'head', 'table__head');
      const description = tagBuilder([el], 'span', 'description', 'table__description');
      const notes = tagBuilder([el], 'span', 'notes', 'table__notes');
      const info = tagBuilder([el], 'span', 'info', 'table__info');
      const warning = tagBuilder([el], 'span', 'warning', 'table__warning');
      return `<${tag}>${head}${description}${notes}${info}${warning}</${tag}>`;
    })
    .join('');
};

const tagBuilder = (list, tag, prop = null, classes = '') => {
  return list
    .map((el) => {
      const consider_value = !prop ? el : el[prop];
      const print_value = consider_value ? consider_value : '';
      return `<${tag} class='${classes}'>${print_value}</${tag}>`;
    })
    .join('');
};
